import React from 'react';
import {
  BANNER_WIDGET_LAYOUT_TYPE_V2,
  BannerWidgetDetailV2,
  BannerWidgetRequestPayloadV2,
  WIDGET_TYPE_V2,
} from '../../../../../types/widget';
import { getInitialPeriod } from '../../common/utils/getInitialPeriod';
import BannerWidgetForm from './BannerWidgetForm';

export interface BannerWidgetFormWrapperProps {
  isEdit: boolean;
  initialValue?: BannerWidgetDetailV2;
  onChangeType: (type: WIDGET_TYPE_V2) => void;
  onFinish: (value: BannerWidgetRequestPayloadV2) => void;
}

const BannerWidgetFormWrapper = (props: BannerWidgetFormWrapperProps): JSX.Element => {
  const { initialValue, isEdit, onFinish, onChangeType } = props;

  const { exposurePeriod, ...restInitialValue } = initialValue || {};

  const formInitialValue = {
    type: WIDGET_TYPE_V2.BANNER,
    layoutType: BANNER_WIDGET_LAYOUT_TYPE_V2.SWIPE_MARGIN,
    exposurePeriod: getInitialPeriod(exposurePeriod),
    ...restInitialValue,
  };

  return (
    <BannerWidgetForm isEdit={isEdit} initialValue={formInitialValue} onFinish={onFinish} onChangeType={onChangeType} />
  );
};

export default BannerWidgetFormWrapper;
